export const TITLE = "ui.head.profile_title";
